import "../features/product/hydration/ProductsContainerHydration";
import "../features/product/hydration/SingleProductContainerHydration";
import "../features/contact/hydration/ContactContainerHydration";
import "../features/header/headerActions/hydration/HeaderActionsContainerHydration";
import "../features/header/mobileActions/hydration/MobileActionsContainerHydration";
import "../features/header/megaMenu/CategoryMegaMenuHydration";
import "../features/home/partials/featuredProducts/FeaturedProductsHydration";

// Define types for our component mappings
interface ComponentMapping {
  id: string;
  hydrateFn: string;
}

// Define global hydration functions that will be attached to window
declare global {
  interface Window {
    hydrateProductsContainer?: (id: string) => void;
    hydrateSingleProductContainer?: (id: string) => void;
    hydrateContactContainer?: (id: string) => void;
    hydrateHeaderActionsContainer?: (id: string) => void;
    hydrateMobileActionsContainer?: (id: string) => void;
    hydrateCategoryMegaMenu?: (id: string) => void;
    hydrateFeaturedProducts?: (id: string) => void;
    [key: string]: any;
  }
}

const initHydration = (): void => {
  console.log("Hydration system initialized");

  // --- START MODIFICATION ---
  // Hydrate single-instance components
  const singleInstanceMappings: ComponentMapping[] = [
    { id: "products-archive-root", hydrateFn: "hydrateProductsContainer" },
    { id: "single-product-root", hydrateFn: "hydrateSingleProductContainer" },
    { id: "contact-root", hydrateFn: "hydrateContactContainer" },
    {
      id: "header-actions-container",
      hydrateFn: "hydrateHeaderActionsContainer",
    },
    {
      id: "mobile-actions-container",
      hydrateFn: "hydrateMobileActionsContainer",
    },
    { id: "category-mega-menu-root", hydrateFn: "hydrateCategoryMegaMenu" },
  ];

  singleInstanceMappings.forEach(({ id, hydrateFn }) => {
    const rootElement = document.getElementById(id);
    if (rootElement && typeof window[hydrateFn] === "function") {
      if (rootElement.dataset.reactInitialized !== "true") {
        window[hydrateFn](id);
      } else {
        console.log(
          `Skipping hydration for already initialized container: ${id}`
        );
      }
    } else if (rootElement && typeof window[hydrateFn] !== "function") {
      console.warn(
        `Hydration function ${hydrateFn} not found for element ${id}`
      );
    }
  });

  // Hydrate multiple-instance components by attribute
  const multiInstanceSelector = '[data-component="featured-products"]';
  const featuredProductElements = document.querySelectorAll(
    multiInstanceSelector
  );

  featuredProductElements.forEach((element) => {
    const rootId = element.id;
    const hydrateFnName = "hydrateFeaturedProducts";

    if (rootId && typeof window[hydrateFnName] === "function") {
      if (element.getAttribute("data-react-initialized") !== "true") {
        window[hydrateFnName](rootId);
      }
    } else if (!rootId) {
      console.warn(
        `Element with selector '${multiInstanceSelector}' has no ID. Cannot hydrate.`
      );
    }
  });
  // --- END MODIFICATION ---
};

if (typeof window !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHydration);
  } else {
    initHydration();
  }
}

export default initHydration;
